import { useEffect, useState, useMemo } from 'react'
import { getObjectsWithFilter } from '../../../api/apiClientCrud'
import { toast } from 'react-toastify'
import ListModule from '../../module/ListModule'
import { useAuth } from '../../../context/AuthContext'
import { useOutletContext } from 'react-router-dom'
import { getIncomeColumns } from './AccountingFields'
import Loading from '../../common/Loading'
import { Box } from '@mui/material'

const ListIncomes = () => {
  const [customers, setCustomers] = useState([])
  const { user } = useAuth()
  const userRight = useOutletContext()

  const columns = useMemo(() => {
    return getIncomeColumns({ customers })
  }, [customers])

  const options = useMemo(
    () => ({
      objectType: 'incomes',
      accessRight: userRight,
      objectFilter: () => ({ company_id: user.company_id }),
      actions: {
        add: true,
        edit: true,
        view: true,
        delete: {
          message: 'Voulez-vous vraiment supprimer'
        }
      },
      showTotal: { display: true, label: 'Montant total', field: 'totalAmount', type: 'currency' },
      isExpand: false,
      columns
    }),
    [userRight, user.company_id, columns]
  )

  const toolbar = useMemo(
    () => ({
      objectType: 'incomes',
      title: 'Encaissements',
      accessRight: userRight,
      actions: {
        add: true
      },
      isFilter: true,
      columns: options.columns,
      columnVisibility: true
    }),
    [userRight, options]
  )

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await getObjectsWithFilter('customers', {
          company_id: user.company_id
        })
        setCustomers(res.data.customers)
      } catch {
        toast.error('Erreur lors du chargement', { autoClose: 2000 })
      }
    }
    fetchCustomers()
  }, [user.company_id])

  if (!columns.length)
    return (
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          height: '100%',
          minHeight: '100px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Loading />
      </Box>
    )
  return <ListModule options={options} toolbar={toolbar} />
}

export default ListIncomes
